import { ReactNode } from "react";
import { Testable } from "~/lib/testing";

export function CardSection({
    title,
    subtitle,
    children,
    rightElement,
    ...props
}: {
    title: string;
    subtitle?: string;
    children?: ReactNode;
    rightElement?: ReactNode;
} & Testable) {
    return (
        <section className="flex flex-col gap-4 border border-blue-20 bg-white py-6 sm:rounded-lg">
            <div className="flex flex-col gap-4 px-6" data-test-id={props["data-testid"]}>
                <div>
                    {rightElement && <div className="float-right">{rightElement}</div>}
                    <h3 className="font-header-small uppercase text-blue-80">{title}</h3>
                </div>
                {subtitle && <span className="font-subheader-1 text-gray-80">{subtitle}</span>}
            </div>
            {children}
        </section>
    );
}
